import styled from 'styled-components';
import { StyledHeaderProps } from './Header.types';

export const StyledHeader = styled.header<StyledHeaderProps>`
  ${(props) =>
    props.hasContainerProps
      ? `.container { display: flex; }`
      : `display: flex;`}

  .header__burger {
    background-color: transparent;
    border-style: none;
    padding: 0;
    cursor: pointer;
  }

  .header__logo {
    background-color: transparent;
    border-style: none;
    padding: 0;
    cursor: pointer;
  }

  ${(props) => props.customStyle}
`;
